// extracted by mini-css-extract-plugin
module.exports = {"Burger":"burger__Burger__QkVd9"};